module.exports = __webpack_public_path__ + "img/box6-img-2.f4e49a3c.png";